import queryString from 'query-string'
import { throwError } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'
import { env } from 'shared/env'

const baseURL = env.SERVER_ADDR

const requestHeader = () => {
  const headers = {
    'Content-Type': 'application/json',
  }
  const userData = JSON.parse(localStorage.getItem('user_info') || '{}')
  let token: string | boolean = false
  if (userData.token) {
    token = userData.token
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}

const handleError = (operation: string) => (err: any) => {
  const errMsg = `Error in ${operation}()`

  if (err.status === 401) {
    localStorage.clear()
    window.location.href = '/auth/login'
  }
  return throwError(() => console.error(errMsg))
}

export const getInvoices = (filters) => {
  const stringified = queryString.stringify(filters)
  return ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice?${stringified}`,
  }).pipe(catchError(handleError('login')))
}

export const getInvoiceStats = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/stats`,
  }).pipe(catchError(handleError('getInvoiceStats')))

export const getCustomerbyId = (id) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${id}`,
  }).pipe(catchError(handleError('login')))

export const getInvoicesMeta = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/meta`,
  }).pipe(catchError(handleError('login')))

export const getCustomer = (value) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/customer?search=${value}`,
  }).pipe(catchError(handleError('getCustomer')))

export const getInvoiceDetail = (invoice_id) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}`,
  }).pipe(catchError(handleError('login')))

export const searchCustomer = (s: string) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/customer?search=${s}`,
  }).pipe(catchError(handleError('login')))

export const addShipping = (data, invoice_id) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/shipping
    `,
    body: data,
  }).pipe(catchError(handleError('login')))

export const deleteShipping = (invoice_id, item_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/shipping/${item_id}
    `,
  }).pipe(catchError(handleError('login')))

export const addDiscount = (data, invoice_id) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/discount
    `,
    body: data,
  }).pipe(catchError(handleError('login')))

export const deleteDiscount = (invoice_id, item_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/discount/${item_id}
    `,
  }).pipe(catchError(handleError('login')))

export const getCustomerDetail = (customer_id) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${customer_id}`,
  }).pipe(catchError(handleError('login')))

export const addPayment = (invoice_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/payment
    `,
    body: data,
  }).pipe(catchError(handleError('login')))

export const duplicateInvoice = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice
    `,
    body: data,
  }).pipe(catchError(handleError('login')))

export const updateInvoiceInfo = (invoice_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const updateCustomer = (invoice_id, coustomer_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/customer/${coustomer_id}`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const getUSState = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/options/countries/US/states
    `,
  }).pipe(catchError(handleError('login')))

export const updateInvoice = (invoice_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/lineitem`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const sendingEmail = (invoice_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/send/email`,
    body: data,
  }).pipe(catchError(handleError('sendingEmail')))

export const deleteInvoiceProduct = (invoice_id, line_item_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/lineitem
      `,
    body: { line_items: line_item_id },
  }).pipe(catchError(handleError('login')))

export const deleteInvoiceDiscountLine = (invoice_id, product_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/discount/${product_id}`,
  }).pipe(catchError(handleError('login')))

export const addShippingPaymentLine = (order_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/orders/${order_id}/payments`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const getCustomerPaymentMethods = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/payment/options`,
  }).pipe(catchError(handleError('login')))

export const addNewPaymentMethod = (customer_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${customer_id}/payment-method`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const addNewPaymentLine = (invoice_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/payment`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const addinvoiceDiscountLine = (invoice_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/discount`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const addInvoiceShippingLine = (invoice_id: number, data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/shipping`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const deleteInvoiceShippingLine = (invoice_id, product_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/shipping/${product_id}`,
  }).pipe(catchError(handleError('login')))

export const addNewInvoice = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const getTaxRates = (zip: string) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/options/${zip}/taxes`,
    // body: data,
  }).pipe(catchError(handleError('login')))

export const unSendInvoice = (invoice_id: number) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice/${invoice_id}/unSend`,
  }).pipe(catchError(handleError('unSendInvoice')))
